<template>
  <div class="bus-set-conta">
    <div class="bus-left-con">
      <h1 class="left-title">业务设置</h1>
      <div class="left-tab">
        <p class="left-tab-item" :class="type == 'newyorker' && 'active'" @click="type = 'newyorker'" v-if="agentStatus != 4">新客池规则设置</p>
        <p class="left-tab-item" :class="type == 'publicRule' && 'active'" @click="type = 'publicRule'">公客池规则设置</p>
        <p class="left-tab-item" :class="type == 'follow' && 'active'" @click="type = 'follow'">客户跟进规则设置</p>
        <p class="left-tab-item" :class="type == 'customeNum' && 'active'" @click="type = 'customeNum'" v-if="agentStatus != 4">客户上限设置</p>
        <p class="left-tab-item" :class="type == 'level' && 'active'" @click="type = 'level'">客户等级自定义</p>
        <p class="left-tab-item" :class="type == 'task' && 'active'" @click="type = 'task'">待办任务逾期规则</p>
        <!-- <p class="left-tab-item" :class="type == 'sale' && 'active'" @click="type = 'sale'">小云智能销售小助手</p> -->
      </div>
    </div>
    <div class="bus-right-con">
      <component :is="componentList[type]" :agentStatus="`${agentStatus}`"></component>
    </div>
  </div>
</template>
<script>
import {getCompanyAgentStatus} from '@/api/system';
export default{
  name: 'BussinessSetting',
  data () {
    return {
      type: '',
      componentList: {
        'newyorker': () => import('./newYork/index'),
        'publicRule': () => import('./public/index'),
        'follow': () => import('./follow/index'),
        'customeNum': () => import('./customNum/index'),
        'level': () => import('./level/index'),
        'task': () => import('./task/index'),
        // 'sale': () => import('./saleAssistant/index'),
      },
      agentStatus: 0
    }
  },
  created() {
    this.initAgentStatus();
  },
  methods: {
    async initAgentStatus () {
      try {
        const res = await getCompanyAgentStatus();
        this.agentStatus = res.agent_type;
        const type = this.$route.query.type;
        if(type){
          this.type = type
        }else{
          this.type = res.agent_type == 4 ? 'publicRule' : 'newyorker';
        }
      } catch (error) {
        this.agentStatus = 0;
      }
    }
  },
}
</script>
<style lang="less">
@import url('~@/assets/style/setting/bussSetting.less');
</style>
<style lang="less" scoped>
.bus-set-conta{
  height: calc(100% - 42px);
  display: -webkit-box;
  background: #fff;
  .bus-left-con{
    border-right: 1px solid #dfdfdf;
    width: 185px;
    padding-top: 20px;
  }
  .left-title{
    font-size: 16px;
    color: #333;
    padding-left: 30px;
    font-weight: bold;
  }
  .left-tab{
    margin-top: 15px;
  }
  .left-tab-item{
    line-height: 40px;
    font-size: 14px;
    padding-left: 30px;
    color: #666;
    cursor: pointer;
    &:hover{
      background: #EFF9FF;
    }
  }
  .left-tab-item.active{
    background: #EFF9FF;
  }
  .bus-right-con{
    -webkit-box-flex: 1;
    padding: 30px;
    height: calc(100VH - 92px);
    overflow-y: scroll;
  }
}
</style>